<app-main-layout>
  <app-telegram-page></app-telegram-page>
</app-main-layout>
